@if (purchaseLimitsErrorDetails) {
    <show-message id="purchaseLimitsErrorDetails" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.decline.message' | translate }}</strong>
            <br />
            <p>{{ 'PARTY.CASHIER.web.deposit.purchaselimits.message' | translate }}</p>
        </div>
    </show-message>
}

@if (rgLimitsErrorDetails) {
    <show-message id="rgLimitsErrorDetails" [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.deposit.rglimitsexceeded.header.message' | translate }}</strong>
            <br />
            <div>
                @switch (rgLimitsErrorDetails?.errorCode) {
                    @case ('116') {
                        <p>{{ 'PARTY.CASHIER.web.deposit.rglimitsexceeded.daily.message' | translate }}</p>
                    }
                    @case ('117') {
                        <p>{{ 'PARTY.CASHIER.web.deposit.rglimitsexceeded.weekly.message' | translate }}</p>
                    }
                    @case ('118') {
                        <p>{{ 'PARTY.CASHIER.web.deposit.rglimitsexceeded.monthly.message' | translate }}</p>
                    }
                }
            </div>
        </div>
    </show-message>
}

@if (instrumentDepositLimitErrorDetails) {
    <show-message id="instrumentDepositLimitErrorDetails" [type]="messageType.ERROR">
        <div error>
            <span>
                @switch (instrumentDepositLimitErrorDetails.errorMessage) {
                    @case ('INSTRUMENT_DEPOSIT_LIMIT_EXCEEDED') {
                        <p>{{ 'PARTY.CASHIER.web.deposit.instrument.limit.exceeded.message' | translate }}</p>
                    }
                    @case ('INSTRUMENT_DEPOSIT_LIMIT_TO_BE_EXCEEDED') {
                        <p>{{ 'PARTY.CASHIER.web.deposit.instrument.limit.revised.amount.message' | translate }}</p>
                    }
                }
            </span>
        </div>
    </show-message>
}
